import { FULL_HD, HD, RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { getElementSize } from '../utils/sizes';
import { ITEMS_BY_BREAKPOINTS } from './customer/default/bigSquare.constants';

export const templates = {
  BigSquare: 'BigSquare',
};

export const imageOptions = {
  [templates.BigSquare]: {
    [RENDERING_CONTEXT.GENERAL]: {
      [HD]: {
        PRIMARY: {
          width: 80,
          height: 80,
        },
      },
      [FULL_HD]: {
        PRIMARY: {
          width: 96,
          height: 96,
        },
      },
    },
  },
};

const heights = {
  [HD]: 189,
  [FULL_HD]: 224,
};

const { sizes: elementSizes } = getElementSize(ITEMS_BY_BREAKPOINTS, 1.0, templates.BigSquare);

const buildSizes = context =>
  [FULL_HD, HD].reduce(
    (acc, size) => ({
      ...acc,
      [size]: {
        w: elementSizes[templates.BigSquare][context][size].w,
        h: heights[size],
      },
    }),
    {},
  );

export const sizes = {
  [templates.BigSquare]: {
    [RENDERING_CONTEXT.GENERAL]: buildSizes(RENDERING_CONTEXT.GENERAL),
    [RENDERING_CONTEXT.SEARCH]: buildSizes(RENDERING_CONTEXT.SEARCH),
  },
};

export { ITEMS_BY_BREAKPOINTS };
